<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Skenirana vozila ({{ totalRecords }})</h3>
                    </template>

                    <!-- FILTERI -->
                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Zona</h4>
                            <base-input>
                                <el-select v-model="filter.clientId" class="select-primary" name="client" clearable>
                                    <el-option v-for="c in clients" class="select-primary" :label="c.name" :value="c.id"
                                        :key="c.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kontrolor</h4>
                            <base-input>
                                <el-select v-model="filter.employeeId" class="select-primary" name="employee" clearable>
                                    <el-option v-for="emp in employees" class="select-primary"
                                        :style="emp.active ? 'color: green;' : 'color:red'"
                                        :label="emp.active ? emp.name + ' ' + emp.lastName + ' AKTIVAN' : emp.name + ' ' + emp.lastName + ' NEAKTIVAN'"
                                        :value="emp.id" :key="emp.id"></el-option>
                                </el-select>
                            </base-input>
                            <base-input label="Broj redova" style="margin-top: 15px;">
                                <el-select v-model="max" class="select-primary" name="rows" style="width: 200px;">
                                    <el-option v-for="r in rows" class="select-primary" :label="r.name" :value="r.value"
                                        :key="r.value"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Filter po kazni</h4>
                            <base-input>
                                <el-select v-model="filter.ticketFilter" class="select-primary" name="ticketFilter">
                                    <el-option label="Sve" value="all"></el-option>
                                    <el-option label="Samo sa kaznom" value="withTicket"></el-option>
                                    <el-option label="Samo bez kazne" value="withoutTicket"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">&nbsp;</h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getCheckedPlates()">Pretraži</base-button>


                        </div>
                    </div>

                    <!-- TABELA -->
                    <el-table :data="checkedPlates" v-loading="tableLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">

                        <el-table-column min-width="140" prop="stamp" label="Datum" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ formatDate(scope.row.stamp) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="plates" label="Tablice" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span>{{ scope.row.client?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" prop="parking" label="Lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.parking?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="employee" label="Kontrolor">
                            <template slot-scope="scope">
                                <span v-if="scope.row.employee">{{ scope.row.employee.name }} {{
                                    scope.row.employee.lastName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="ticketId" label="Kazna">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ticketId" style="color: red;">DA</span>
                                <span v-else style="color: green;">NE</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="a" label="">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ticketId"><base-button :type="'success'" class="btn-link"
                                        @click="getCheckedPlate(scope.row)">
                                        Slike
                                    </base-button></span>
                            </template>
                        </el-table-column>


                    </el-table>

                    <!-- PAGINACIJA -->
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changePage">
                        </base-pagination>
                    </div>
                </card>

                <modal :show.sync="showCheckedPlates" :show-close="true" :scrollToBottom="true" :appendToBody="true"
                    modalClasses="custom-modal" modalContentClasses="custom-modal-content"
                    bodyClasses="custom-modal-body">
                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                        @click="showCheckedPlates = false; checkedPlate = {}">
                        <i class="tim-icons icon-simple-remove"></i>
                    </base-button>


                    <div class="row">
                        <div class="col-md-12">
                            <card>
                                <template v-for="img in checkedPlate?.images">
                                    <img class="card-img" style="width: 150px;"
                                        @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                                        :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                                </template>
                            </card>
                        </div>

                    </div>

                </modal>
            </div>
        </div>
    </div>
</template>

<script>
import { TabPane, Tabs, BasePagination } from 'src/components';
import { Table, TableColumn, DatePicker, Select, Option } from 'element-ui';
import axios from '@/util/axiosinstance';
import { BaseNav, Modal } from '@/components';

const rows = [
    { value: 10, name: "10" },
    { value: 20, name: "20" },
    { value: 50, name: "50" },
    { value: 100, name: "100" },
    { value: 500, name: "500" }
];

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Modal,
        BasePagination
    },
    mounted() {
        this.getClients();
        this.getEmployees();
        this.getUserPageFilter();
    },
    data() {
        const now = new Date();
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            rows,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            loading: false,
            tableLoading: false,
            checkedPlates: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                plates: null,
                clientId: null,
                employeeId: null,
                ticketFilter: 'all'
            },
            employees: [],
            clients: [],
            page: 1,
            max: 100,
            totalRecords: 0,
            totalPages: 0,
            sortField: "stamp",
            sortOrder: "descending",
            checkedPlate: {},
            showCheckedPlates: false
        };
    },
    methods: {
        getCheckedPlate(t) {
            this.loading = true

            axios.get(this.url + '/ticket/getCheckedPlateDashboard?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.checkedPlate = result.data.checkedPlate
                    this.showCheckedPlates = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getUserPageFilter() {
            this.loading = true;

            axios.get(this.url + '/settings/getUserPageFilter?page=22').then(result => {
                this.loading = false;

                if (result.data.result === 'ok' && result.data.filter) {
                    this.filter = result.data.filter;
                }
                this.getCheckedPlates();
            });
        },
        formatDate(timestamp) {
            if (!timestamp) return '';
            return new Date(timestamp).toLocaleString("de-DE");
        },
        changePage(item) {
            this.page = item;
            this.getCheckedPlates();
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;
            this.getCheckedPlates();
        },
        getClients() {
            axios.get(this.url + '/client/getClients').then(result => {
                if (result.data.result === 'ok') {
                    this.clients = result.data.clients;
                }
            });
        },
        getEmployees() {
            const body = {
                onlyActive: false
            }
            axios.post(this.url + '/employee/getEmployees', body).then(result => {
                if (result.data.result === 'ok') {
                    this.employees = result.data.employees;
                }
            });
        },
        getCheckedPlates() {
            this.tableLoading = true;

            const f = {
                ...this.filter,
                page: this.page,
                max: this.max,
                sortField: this.sortField,
                sortOrder: this.sortOrder,
                pageId: '22'
            };

            axios.post(this.url + '/ticket/getAllCheckedPlates', f).then(result => {
                this.tableLoading = false;

                if (result.data.result === 'ok') {
                    this.checkedPlates = result.data.checkedPlates;
                    this.totalPages = result.data.totalPages;
                    this.totalRecords = result.data.totalRecords;
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>